import { $analytics } from '../y/analytics';
import { $api } from '../y/api';
import { YLanguage } from '../y/i18n';
import { YCountryId, YId, YFlagsUpdate } from '../y/types';
import { MNotificationSetting, CUserFlag, cUserAnalyticsProfile } from '../mdl/c-user';
import { the_intercom_user_hash, the_user } from './login';

export function getCountry(): YCountryId {
    return the_user?.country || window.tl_default_country || 'SE';
}

interface MeUpdateRequest {
    email?: string | null;
    country?: YCountryId;
    city_id?: YId;
    first_name?: string;
    last_name?: string;
    gender?: string | null;
    birth_year?: number | null;
    avatar_id?: YId | null;
    language?: YLanguage;
    messages?: YFlagsUpdate<MNotificationSetting>;
    flags?: YFlagsUpdate<CUserFlag>;
}

export function meUpdate(data: MeUpdateRequest) {
    const me = the_user!;
    return $api.PUT('me', data).then(user => {
        Object.assign(me, user);
        $analytics.identify(me.analytics_id, cUserAnalyticsProfile(me), undefined, undefined, undefined, undefined, the_intercom_user_hash);
    })
}

export function meUpdatePhone(phone: string, phone_token: string) {
    const me = the_user!;
    return $api.PUT('me/phone', { phone, phone_token }).then(() => {
        me.phone = phone;
    })
}

export function meChangePassword(old_password: string, new_password: string) {
    return $api.PUT('me/password', { old_password, new_password });
}
